import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { OfficialActDescriptor } from './model/officialact';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class OfficialActService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'OfficialActManagement',
      authService,
      config.OAMSConfig
    );
  }

  public create(officialAct: OfficialActDescriptor): Promise<OfficialActDescriptor> {
    return super.post<OfficialActDescriptor>(
      new OfficialActDescriptor({
        id: undefined,
        href: undefined,
        organizationId: officialAct.organizationId,
        labelId: officialAct.labelId,
        previousActId: officialAct.previousActId,
        rootActId: officialAct.rootActId,
        reference : officialAct.reference,
        actKind: officialAct.actKind,
        actType: officialAct.actType,
        actState: officialAct.actState,
        createdOn: officialAct.createdOn,
        resolutionNumber: officialAct.resolutionNumber,
        filingNumber: officialAct.filingNumber,
        dueDateDays: officialAct.dueDateDays,
        signedOn: officialAct.signedOn,
        receivedOn: officialAct.receivedOn,
        dueDate: officialAct.dueDate,
        clerkId: officialAct.clerkId,
        finalDate: officialAct.finalDate,
        ksznyNumber: officialAct.ksznyNumber,
        revocationFilingNumber: officialAct.revocationFilingNumber,
        modified: officialAct.modified,
        deleted: officialAct.deleted
      }));
  }
  
  public update(id: string, role: OfficialActDescriptor): Promise<OfficialActDescriptor> {
    return super.put<OfficialActDescriptor>(id, role);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  async GetList(v: View): Promise<List<OfficialActDescriptor>> {
    return await this.getOfficialActs(v);
  }

  public getOfficialActs(view?: View): Promise<List<OfficialActDescriptor>> {
    return super.get<List<OfficialActDescriptor>>(undefined, view);
  }

  async GetById(id: string): Promise<OfficialActDescriptor> {
    return await this.getById(id);
  }

  public getById(id: string): Promise<OfficialActDescriptor> {
    return super.get<OfficialActDescriptor>(id);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/officialact/officialact.service.ts